// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
const schema = Object.create(null);
export const registerElementMeta = (meta) => {
    //下面热更新会报错
    // assert(schema[meta.tag] === undefined || schema[meta.tag] === meta);
    schema[meta.tag] = meta;
};
export const getElementMeta = (tag) => {
    return schema[tag];
};
